var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"akshaya-heading"},[_c('h3',[_vm._v("Store Management\n        ")])]),_vm._v(" "),_c('br')])
}]

export { render, staticRenderFns }